import React, { useState } from 'react'
import Shadeddiv from '../Components/Shadeddiv'
import Filterprojects from '../Components/Filterprojects'
import ProjectsCards from '../Components/ProjectsCards'
const Projects = () => {
  const [category,setcategory]=useState("All");
 
  return (
    <div className='bg-aboutbg w-screen relative min-h-screen h-max flex flex-col  justify-evenly items-center gap-10' id='Projects'>
     {/* shaded div */}
     <Shadeddiv shadedtext={"Projects"} underlinetext1={"My"} underlinetext2={" Wor"} underlinetext3={"k"}/>
      <Filterprojects category={category} setcategory={setcategory}/>
      <ProjectsCards category={category} setcategory={setcategory} /> 
    </div>
  )
}

export default Projects
